// import React, { useRef, useState, useEffect } from "react";
import Header from "./header";
const OurProduct = () => {
  const heroContainerStyle = {
    width: "100%",
    // maxWidth: "100%",
    margin: "0 auto",
    paddingTop: "80px",
    maxHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "50px",
    padding: "60px 8%",
    boxSizing: "border-box",
    flexWrap: "wrap",
    backgroundColor: "#fff",
  };
  const imageStyle = {
    width: "100%",
    height: "500px",
    display: "block",
    borderRadius: "10px",
  };
  return (
    <>
      <Header />
      {/* HERO SECTION */}
      <div style={heroContainerStyle}>
          <img src="/images/under.svg" alt="Hero Visual" style={imageStyle} />
      </div>
    </>
  );
};
export default OurProduct;